import React, { Component } from 'react'
import Button from './Button'

class ExternalLink extends Component {
	render() {
		return <a {...this.props}>{this.props.children}</a>
	}
}

export default Button.withComponent(ExternalLink)